module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-accordion-item accordion-item",
    attrs: {
      "data-accordion-item": ""
    }
  }, [_c('a', {
    staticClass: "accordion-title",
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.title))]), _c('div', {
    staticClass: "accordion-content",
    attrs: {
      "data-tab-content": ""
    }
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-58c6c959!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/foundation/Accordion/AccordionItem.vue
// module id = 2513
// module chunks = 1